<template>
    <component
        v-if="assetComponent"
        :is="assetComponent"
        aria-hidden="true"
        role="presentation" />
</template>

<script lang="ts">
    import { defineComponent, PropType, computed, h } from 'vue';
    import { Type, assetTypes } from './Asset.interfaces';
    import * as Assets from '@ui/components/Asset/Asset.imports';

    export default defineComponent({
        name: 'Asset',
        props: {
            type: { type: String as PropType<Type | null> },
        },
        setup(props) {
            const getComponent = (type: Type) => {
                // eslint-disable-next-line import/namespace
                const dynamicAsset = Assets[type];
                if (!dynamicAsset) {
                    console.error(`Asset component not found for type: ${type}`);
                    return null;
                }
                return {
                    render() {
                        return h(dynamicAsset);
                    },
                };
            };

            return {
                assetComponent: computed(() =>
                    props.type && assetTypes.includes(props.type)
                        ? getComponent(props.type)
                        : null
                ),
            };
        },
    });
</script>
